import "@backstage/cli/asset-types";
import "@backstage/ui/css/styles.css";
import "./canon-brand-overrides.css";

import ReactDOM from "react-dom/client";

import app from "./App";

// `app` is an ELEMENT, not a component: the new frontend system's `createApp().createRoot()` takes no
// arguments and returns the assembled root element, where the legacy `app.createRoot(<element/>)`
// returned a component to instantiate. So this renders `app`, not `<App />`.
ReactDOM.createRoot(document.getElementById("root")!).render(app);
